import { defaultErrorToTerm } from '../../../otherBusinessLogic/defaultErrorToTerm';

export function errorToTerm(exception: unknown): string {
  return defaultErrorToTerm(exception) ?? 'env_renaming_unknown_error';
}
